import { encryptData, decryptData } from './crypto-utils';

export const secureSessionStorage = {
  async setItem(key, value) {
    try {
      const encrypted = await encryptData(value);
      sessionStorage.setItem(key, encrypted);
    } catch {
      sessionStorage.removeItem(key);
    }
  },
  async getItem(key) {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    try {
      return await decryptData(raw);
    } catch {
      return null;
    }
  },
  removeItem(key) { sessionStorage.removeItem(key); }
};

export const secureLocalStorage = {
  async setItem(key, value) {
    try {
      const encrypted = await encryptData(value);
      localStorage.setItem(key, encrypted);
    } catch {
      localStorage.removeItem(key);
    }
  },
  async getItem(key) {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    try {
      return await decryptData(raw);
    } catch {
      return null;
    }
  },
  removeItem(key) { localStorage.removeItem(key); }
};
